import { Link } from "react-router-dom";
import { TEAM_GROUPS } from "@/data/team";

const MEMBERS = TEAM_GROUPS.flatMap((g) => g.members);

export const speakerList = (speaker) =>
  (speaker || "").split(" · ").map((s) => s.trim()).filter(Boolean).map((label) => {
    const m = MEMBERS.find((x) => label.includes(x.name) || x.name.includes(label.split(" (")[0]));
    return { label, member: m || null };
  });

export const SpeakerChips = ({ speaker, dark = true, size = "md", testId = "speakers" }) => {
  const list = speakerList(speaker);
  if (!list.length) return null;
  const sub = dark ? "text-[rgba(244,241,234,.55)]" : "text-[var(--muted)]";
  const ring = dark ? "border-[rgba(212,168,77,.45)]" : "border-[var(--line-l)]";
  const px = size === "sm" ? "h-7 w-7" : "h-9 w-9";
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-2 ${size === "sm" ? "text-[12px]" : "text-[13px]"}`} data-testid={testId}>
      {list.map(({ label, member }, i) =>
        member ? (
          <Link key={label} to={`/team/${member.slug}`} className="group inline-flex items-center gap-2 min-w-0" data-testid={`${testId}-${i}`} title={`${member.name}, ${member.title}`}>
            <img src={member.image} alt={member.name} loading="lazy" className={`${px} rounded-full object-cover object-top border ${ring} shrink-0`} />
            <span className="min-w-0 leading-tight">
              <span className={`block font-semibold group-hover:underline ${dark ? "text-[var(--cream)]" : "text-[var(--ink)]"}`}>{label}</span>
              {size !== "sm" && <span className={`block text-[11px] ${sub}`}>{member.title}</span>}
            </span>
          </Link>
        ) : (
          <span key={label} className={`inline-flex items-center gap-2 ${sub}`} data-testid={`${testId}-${i}`}>
            <span className={`${px} rounded-full border ${ring} inline-flex items-center justify-center font-serif text-xs ${dark ? "text-[var(--gold-2)]" : "text-[#9a7225]"}`}>{label.split(" ").map((w) => w[0]).slice(0, 2).join("")}</span>
            <span className="font-semibold">{label}</span>
          </span>
        ),
      )}
    </div>
  );
};
